export const UNTITLED_CHAT_TITLE = 'New chat';
const TITLE_GENERATION_GRACE_MS = 2 * 60 * 1000;

export function isChatTitlePending(
  title: string | null | undefined,
  createdAt: Date,
  now: Date = new Date()
): boolean {
  if (title?.trim()) return false;
  return now.getTime() - createdAt.getTime() < TITLE_GENERATION_GRACE_MS;
}
